import * as React from 'react';
import { CSSProperties } from 'react';
import { ComboBoxInput as ComboBoxInput2 } from '../dropdown/ComboBoxInput2';

type Props<D extends unknown = unknown> = {
  options: D[];
  labelFunction?: ((item: D) => string) | keyof D;
  value?: D | string | null;
  defaultValue?: D | string | null;
  rootClassName?: string;
  disabled?: boolean;
  emptyLabel?: string;
  errorText?: string;
  variant?: 'normal' | 'formInput';
  calloutMaxHeight?: number;
  noPlaceholder?: boolean;
  onValueChanged: (value: string | null, option: D | null) => void;
  style?: CSSProperties;
  virtualized?: boolean;
  testId?: string;
  required?: boolean;
};

export function ComboBoxInput<D extends unknown = unknown>(props: Props<D>) {
  return (
    <ComboBoxInput2
      options={props.options}
      required={props.required ?? true}
      getOptionLabel={props.labelFunction as any}
      value={props.value as any}
      rootClassName={props.rootClassName}
      disabled={props.disabled}
      placeholder={props.emptyLabel}
      errorText={props.errorText}
      variant={props.variant}
      useVirtualization={props.virtualized}
      testId={props.testId}
      onValueChanged={(value) => {
        if (props.options.includes(value as any))
          props.onValueChanged(null, value as any);
        else props.onValueChanged(value as any, null);
      }}
    />
  );
}
